import Logo from '@/components/Shared/Logo'
import styles from './styles.module.scss'

interface SimpleHeaderProps {
  used?: 'additional_info' | 'group_join'
}

const HEADER_TITLES: Record<string, string> = {
  additional_info: 'プロフィール追加登録',
  group_join: 'グループに参加',
}

export default function SimpleHeader({ used }: SimpleHeaderProps) {
  const headerClass =
    used === 'additional_info'
      ? `${styles.simpleHeader} ${styles.additionalInfo}`
      : styles.simpleHeader

  const title = used ? HEADER_TITLES[used] : null

  return (
    <header className={headerClass}>
      <div className={styles.container}>
        <div className={styles.logoWrapper}>
          <Logo />
        </div>
        {title && (
          <div className={styles.titleWrapper}>
            <h1 className={styles.title}>{title}</h1>
          </div>
        )}
      </div>
    </header>
  )
}
